import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const SHELL_DESTINATIONS = [
    { value: 'today', label: 'Today' },
    { value: 'strategies', label: 'Strategies' },
    { value: 'trade', label: 'Trade' },
    { value: 'platform', label: 'Platform' },
    { value: 'more', label: 'More' },
    { value: 'research', label: 'Research' },
    { value: 'admin', label: 'Admin' },
    { value: 'docs', label: 'Docs' },
];

export const DASHBOARD_VIEWS = [
    { value: 'positions', label: 'Positions' },
    { value: 'fundsmargins', label: 'Funds' },
    { value: 'control', label: 'Control' },
    { value: 'hftstudio', label: 'HFT Studio' },
    { value: 'ticklake', label: 'Tick Studio' },
    { value: 'infrahealth', label: 'iHealth' },
    { value: 'phealth', label: 'pHealth' },
    { value: 'strategyhealth', label: 'sHealth' },
    { value: 'screeners', label: 'Screeners' },
    { value: 'tradinghub', label: 'Trading Hub' },
    { value: 'qcockpit', label: 'qCockpit' },
    { value: 'diagnostics', label: 'Diagnostics' },
    { value: 'stratperf', label: 'Strategy Perf' },
    { value: 'tradingcockpit', label: 'Trading Cockpit' },
    { value: 'optionchain',   label: 'Option Chain' },
    { value: 'docs',          label: 'Docs' },
];

const DashboardViewContext = createContext({
    view: DASHBOARD_VIEWS[0].value,
    setView: () => {},
    refreshKey: 0,
    triggerRefresh: () => {},
});

export const DashboardViewProvider = ({ children }) => {
    const [view, setView] = useState(DASHBOARD_VIEWS[0].value);
    const [refreshKey, setRefreshKey] = useState(0);

    const triggerRefresh = useCallback(() => {
        setRefreshKey((prev) => prev + 1);
    }, []);

    const value = useMemo(
        () => ({
            view,
            setView,
            refreshKey,
            triggerRefresh,
        }),
        [view, refreshKey, triggerRefresh]
    );

    return <DashboardViewContext.Provider value={value}>{children}</DashboardViewContext.Provider>;
};

export const useDashboardView = () => useContext(DashboardViewContext);
